var map = {
	"./leaf-1-night.svg": 5154,
	"./leaf-1.svg": 9479,
	"./leaf-2-night.svg": 2865,
	"./leaf-2.svg": 1620,
	"./leaf-3-night.svg": 128,
	"./leaf-3.svg": 2901,
	"./leaf-4-night.svg": 223,
	"./leaf-4.svg": 1274,
	"./leaf-5-night.svg": 9510,
	"./leaf-5.svg": 3243,
	"./leaf-6-night.svg": 3061,
	"./leaf-6.svg": 1880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3066;